<ng-container>
  <c-card-body [ngClass]="bodyClasses">
    <div>
      <div *ngIf="!!value || templates?.widgetValueTemplate" class="fs-4 fw-semibold">
        <ng-container *ngTemplateOutlet="templates?.widgetValueTemplate || defaultWidgetValueTemplate"></ng-container>
      </div>
      <div *ngIf="!!title || templates?.widgetTitleTemplate">
        <ng-container *ngTemplateOutlet="templates?.widgetTitleTemplate || defaultWidgetTitleTemplate"></ng-container>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="templates?.widgetActionTemplate || defaultWidgetActionTemplate"></ng-container>
  </c-card-body>
  <ng-container *ngTemplateOutlet="templates?.widgetChartTemplate || defaultWidgetChartTemplate"></ng-container>
</ng-container>

<ng-template #defaultWidgetTitleTemplate>
  {{title}}
</ng-template>

<ng-template #defaultWidgetValueTemplate>
  {{value}}
</ng-template>

<ng-template #defaultWidgetChartTemplate>
  <ng-content select=".chart-wrapper"></ng-content>
</ng-template>

<ng-template #defaultWidgetActionTemplate>
  <ng-content></ng-content>
</ng-template>
